import React from 'react';
import './ChildSafety.scss';
import images from './assets/images';

const ChildSafety = () => {
  const onClickHome = () => {
    window.location.href = '/';
  };

  return (
    <div className={'ChildSafety-page'}>
      <div className={'ChildSafety-container'}>
        <div className={'ChildSafety-header'} onClick={onClickHome}>
          <img src={images.ic_app} className={'ChildSafety-app-icon'} alt={'QueenTalk Logo'} />
          <div>
            <h1 className={'ChildSafety-brand-text'}>{'QueenTalk'}</h1>
            <p className={'ChildSafety-brand-sub'}>{'퀸톡 아동 안전 표준 및 정책 센터'}</p>
          </div>
        </div>

        <h1 className={'ChildSafety-title'}>{'아동 안전 표준 및 CSAE 방지 정책'}</h1>

        <div className={'ChildSafety-meta-box'}>
          <p><strong>{'서비스명:'}</strong> {'퀸톡 (QueenTalk)'}</p>
          <p><strong>{'운영 주체:'}</strong> {'DomiLabs'}</p>
          <p><strong>{'적용 대상:'}</strong> {'퀸톡(QueenTalk) 모바일 애플리케이션 및 관련 웹 서비스 전체'}</p>
          <p><strong>{'시행 일자:'}</strong> {'2024년 1월 1일 (최종 업데이트: 2026년 9월 18일)'}</p>
        </div>

        <div className={'ChildSafety-highlight-box'}>
          <strong>{'[무관용 원칙 (Zero-Tolerance Policy)]'}</strong><br />
          {'퀸톡(QueenTalk)은 아동 및 청소년을 대상으로 하는 성적 학대 및 착취(CSAE, Child Sexual Abuse and Exploitation)와 아동 성착취물(CSAM, Child Sexual Abuse Material)에 대해 어떠한 예외도 없는 무관용 원칙을 철저히 적용합니다.'}
        </div>

        <section className={'ChildSafety-section'}>
          <h2>{'1. 개요 및 정책 목적'}</h2>
          <p>
            {'본 정책은 Google Play 개발자 프로그램 정책의 「아동 안전 표준」 및 대한민국 「아동·청소년의 성보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령에 기반하여 작성되었습니다.'}
          </p>
          <p>
            {'퀸톡(QueenTalk)은 건전하고 안전한 대화 환경을 제공하기 위해 모든 형태의 미성년자 대상 유해 행위를 엄격히 금지하며, 이를 위반하는 행위에 대해 즉각적이고 단호한 법적·기술적 조치를 취하고 있습니다.'}
          </p>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'2. 명시적 금지 행위'}</h2>
          <p>{'퀸톡 서비스 내에서 다음 각 호에 해당하는 모든 행위는 엄격히 금지됩니다:'}</p>
          <ul>
            <li>
              <strong>{'아동 성착취물(CSAM)의 유통 및 소지 금지:'}</strong><br />
              {'아동·청소년이 등장하거나 이를 묘사하는 성착취 사진, 동영상, 음란 이미지, AI 생성 콘텐츠 등을 제작, 업로드, 게시, 전송, 저장, 공유, 중개하는 모든 행위'}
            </li>
            <li>
              <strong>{'온라인 그루밍(Grooming) 및 성적 유인 금지:'}</strong><br />
              {'미성년자의 신뢰를 얻거나 심리적 취약성을 이용해 성적 대화를 유도하거나, 성적 만남을 요구, 제안, 주선하는 행위'}
            </li>
            <li>
              <strong>{'성적 콘텐츠 요구 및 전송 금지:'}</strong><br />
              {'미성년자에게 신체 사진, 성적 이미지, 영상 전송을 요구하거나 이를 대화방 또는 프로필을 통해 전송·공유하는 행위'}
            </li>
            <li>
              <strong>{'성매매 및 성착취 알선 금지:'}</strong><br />
              {'금전, 물품, 숙식 제공 등 대가를 조건으로 미성년자에게 성적 행위를 유도하거나 알선하는 일체의 행위'}
            </li>
            <li>
              <strong>{'미성년자 사칭 및 유인 행위:'}</strong><br />
              {'성인이 미성년자로 가장하거나 반대로 미성년자를 대상으로 성적 접촉을 시도하는 모든 행위'}
            </li>
          </ul>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'3. 위반 시 조치 및 계정 제재'}</h2>
          <p>{'아동 안전 및 CSAE 관련 정책 위반 또는 의심 정황이 확인될 경우, 퀸톡은 사전 통보 없이 다음 조치를 즉각 시행합니다:'}</p>
          <ul>
            <li>
              <strong>{'콘텐츠 즉각 삭제:'}</strong><br />
              {'해당 메시지, 사진, 프로필 등 위반 콘텐츠의 서버 내 즉시 영구 삭제 및 격리'}
            </li>
            <li>
              <strong>{'계정 영구 정지 및 기기 차단:'}</strong><br />
              {'가해 계정의 영구 탈퇴 처리 및 해당 단말기(디바이스 식별자)와 전화번호의 재가입 영구 차단'}
            </li>
            <li>
              <strong>{'사법기관 고발 및 수사 공조:'}</strong><br />
              {'관련 법률에 따라 대한민국 경찰청 사이버수사대 및 국제 아동보호기구(NCMEC 등)에 즉각 증거 자료를 제출하고 정식 수사를 의뢰'}
            </li>
          </ul>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'4. 이용자 신고 및 접수 방법'}</h2>
          <p>{'퀸톡은 모든 이용자가 아동 안전 위협 요소 및 부적절한 사용자를 즉각 신고할 수 있는 다중 신고 채널을 24시간 운영하고 있습니다:'}</p>
          <ul>
            <li>
              <strong>{'앱 내 대화방 즉시 신고:'}</strong><br />
              {'채팅방 우측 상단 더보기 [⋮] 메뉴 또는 해당 메시지를 길게 눌러 [신고하기] 선택 시 즉시 운영진에 긴급 인입됩니다.'}
            </li>
            <li>
              <strong>{'프로필 화면 신고 및 차단:'}</strong><br />
              {'상대방 프로필 화면의 [신고하기] 및 [차단하기] 기능을 통해 추가 접촉을 즉시 차단하고 검토를 요청할 수 있습니다.'}
            </li>
            <li>
              <strong>{'공식 이메일 직통 접수:'}</strong><br />
              {'앱 외부에서도 아래 전담 이메일로 상대방 닉네임, 발생 일시, 대화 캡처 등을 첨부하여 신고하실 수 있으며 접수 즉시 최우선 검토 및 처리됩니다.'}
            </li>
          </ul>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'5. 아동 안전 및 CSAE 전담 연락처'}</h2>
          <p>{'아동 안전, CSAE 관련 신고, 피해 상담 및 정책 문의는 아래 공식 창구로 연락 주시기 바랍니다:'}</p>
          <div className={'ChildSafety-contact-card'}>
            <p><strong>{'서비스명:'}</strong> {'퀸톡 (QueenTalk)'}</p>
            <p><strong>{'운영사:'}</strong> {'DomiLabs'}</p>
            <p><strong>{'아동 안전 및 개인정보 보호 책임자:'}</strong> {'kevin85.oh@gmail.com'}</p>
            <p><strong>{'공식 신고 및 고객지원 이메일:'}</strong> <a href={'mailto:kevin85.oh@gmail.com'}>{'kevin85.oh@gmail.com'}</a></p>
          </div>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'6. 관계 법령 준수 및 외부 지원 기관'}</h2>
          <p>
            {'퀸톡(QueenTalk)은 사법당국 및 전문 보호기관의 요청에 성실히 협조하며, 피해 발생 시 아래 전문 기관을 통해서도 즉각적인 도움과 상담을 받으실 수 있습니다:'}
          </p>
          <ul>
            <li>{'경찰청 사이버수사국: 국번없이 182 (ecrm.police.go.kr)'}</li>
            <li>{'여성가족부 디지털 성범죄 피해자 지원센터: 02-735-8994 (d4u.stop.or.kr)'}</li>
            <li>{'방송통신심의위원회 디지털 성범죄 신고: 국번없이 1377 (kocsc.or.kr)'}</li>
            <li>{'아동보호전문기관 / 긴급신고: 국번없이 112'}</li>
          </ul>
        </section>

        <section className={'ChildSafety-section'}>
          <h2>{'7. 정책 적용 및 개정 이력'}</h2>
          <p>{'본 정책은 퀸톡(QueenTalk)을 이용하는 모든 회원 및 서비스 방문자에게 예외 없이 적용됩니다.'}</p>
          <p>{'시행일자: 2024년 1월 1일'}</p>
          <p>{'최종 개정 및 적용일자: 2026년 9월 18일'}</p>
        </section>

        <footer className={'ChildSafety-footer'}>
          <p>{'© DomiLabs. All rights reserved.'}</p>
          <p>
            <a href={'/'}>{'홈으로'}</a>
            {'|'}
            <a href={'/privacy_policy.html'}>{'개인정보처리방침'}</a>
            {'|'}
            <a href={'/service_policy.html'}>{'이용약관'}</a>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default ChildSafety;